export default __webpack_public_path__ + "static/cctv-5f8f4329b15503b6a216ab03319b8a2a.png";